// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"32d1ec4c","769":"923a6e02"}[chunkId] + ".chunk.js";
};